export const blockIconsFileCloudOff = (
	<span className='material-symbols-outlined'>cloud_off</span>
);
